module.exports = __webpack_public_path__ + "img/undo.fd12396f.svg";